import React from 'react';

type Props = {
  isZeroResults: boolean;
  zeroResultsMessage: string;
  query: string;
};

export const SearchState: React.FC<Props> = ({ isZeroResults, zeroResultsMessage, query }) => {
  return (
    <div className='col-12' style={{ minHeight: 40 }}>
      <p className='standfirst standfirst--small muted my-2'>
        {query.length > 0 && !isZeroResults
          ? 'Search results for %s'.replace('%s', `“${query}”`)
          : null}
        {isZeroResults ? zeroResultsMessage : null}
      </p>
    </div>
  );
};
